export const getCurrentWeek = () => {
  var date = new Date();
  date.setHours(0, 0, 0, 0);

  //Calcucalte Thursday
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));

  //January 4 is always on first week
  let week1 = new Date(date.getFullYear(), 0, 4);
  return (
    1 +
    Math.round(
      ((date.getTime() - week1.getTime()) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
        7,
    )
  );
};
